import { Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";

// Import logos (removed: Sr. Nuggets, Empira, Ruthless)
import logoShadowBox from "@/assets/inspiration/logo-shadowbox.png";
import logoBloomStudio from "@/assets/inspiration/logo-bloomstudio.png";
import logoUrbanEats from "@/assets/inspiration/logo-urbaneats.png";
import logoTechVerse from "@/assets/inspiration/logo-techverse.png";
import logoBellaModa from "@/assets/inspiration/logo-bellamoda.png";
import logoNexus from "@/assets/inspiration/logo-nexusdigital.png";

const createdBrands = [
  { name: "Bloom Studio", location: "Curitiba, PR", segment: "Yoga Studio", emoji: "🧘", image: logoBloomStudio, isRecent: true },
  { name: "Urban Eats", location: "Campinas, SP", segment: "Food Delivery", emoji: "🍔", image: logoUrbanEats, isRecent: true },
  { name: "TechVerse", location: "Porto Alegre, RS", segment: "Tech Solutions", emoji: "💻", image: logoTechVerse, isRecent: true },
  { name: "Bella Moda", location: "Salvador, BA", segment: "Fashion", emoji: "👗", image: logoBellaModa, isRecent: false },
  { name: "Nexus", location: "Recife, PE", segment: "Marketing", emoji: "📈", image: logoNexus, isRecent: false },
  { name: "Shadow Box", location: "Rio de Janeiro, RJ", segment: "Gaming Startup", emoji: "🎮", image: logoShadowBox, isRecent: false }
];

export const LogoGallery = () => {
  return (
    <section className="py-10 sm:py-16 lg:py-24 bg-muted/30">
      <div className="container mx-auto px-5 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14 lg:mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Sparkles className="h-4 w-4" />
            <span className="text-sm font-medium">Feed de Criações</span>
          </div>
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-display font-bold text-foreground mb-3 sm:mb-4 text-balance">
            🔥 Marcas Criadas com ClickLogos 🔥
          </h2>
          <p className="subtitle-section max-w-2xl mx-auto">
            Veja o que outros empreendedores brasileiros estão criando
          </p>
        </div>

        {/* Logo Grid - Carrossel no Mobile */}
        <div className="flex overflow-x-auto snap-x snap-mandatory gap-4 pl-4 pr-16 pb-4 sm:grid sm:grid-cols-2 lg:grid-cols-3 sm:gap-6 sm:px-0 max-w-6xl mx-auto scrollbar-hide">
          {createdBrands.map((brand, index) => (
            <div 
              key={index}
              className="flex-shrink-0 w-[75vw] max-w-[300px] sm:w-auto sm:max-w-none group bg-card rounded-2xl border border-border hover:border-primary/30 hover:shadow-xl transition-all duration-300 overflow-hidden animate-fade-in snap-center sm:snap-start"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Header com Info */}
              <div className="p-4 border-b border-border/30">
                <div className="flex items-start justify-between mb-2">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      {brand.isRecent && (
                        <span className="relative flex h-2 w-2">
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                        </span>
                      )}
                      <h3 className="font-semibold text-foreground text-lg">
                        {brand.name}
                      </h3>
                    </div>
                    <p className="text-sm text-muted-foreground">
                      {brand.location}
                    </p>
                  </div>
                  {brand.isRecent && (
                    <Badge className="bg-green-900/20 text-green-900 dark:text-green-200 border-green-900/30 animate-pulse">
                      NOVO
                    </Badge>
                  )}
                </div>
              </div>
              
              {/* Logo Image Area */}
              <div className="aspect-[4/3] sm:aspect-square p-4 sm:p-8 flex items-center justify-center bg-muted/30 group-hover:bg-muted/50 transition-colors">
                <img 
                  src={brand.image} 
                  alt={`${brand.name} logo`}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                  width={1024}
                  height={1024}
                  loading="lazy"
                />
              </div>
              
              {/* Footer com Segmento */}
              <div className="p-4 border-t border-border/30">
                <div className="flex items-center gap-2">
                  <span className="text-lg">{brand.emoji}</span>
                  <span className="text-sm font-medium text-foreground">
                    {brand.segment}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
